module.exports = __webpack_public_path__ + "static/media/Rolling-2.4s-200px.b61b2b11.gif";